import RequestFactory from "../../utility/requestFactory";

// trip-service: Operator Broadcast APIs for the logged-in operator.
const BASE = "trip/v1/auth/operator/broadcast";

function errorMessage(err) {
  const body = err && err.body;
  const e = body && body.error;
  if (e && typeof e.message === "string") return e.message;
  if (typeof body === "string") return body;
  return "Something went wrong. Please try again.";
}

function handlers(resolve, reject) {
  return [
    (res) => {
      if (res && res.status >= 200 && res.status < 300) resolve(res.body);
      else reject(new Error(errorMessage(res)));
    },
    (err) => reject(new Error(errorMessage(err))),
  ];
}

export const fetchAccess = () =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi").get(`${BASE}/access`, ok, fail);
  });

export const fetchBookings = (params) =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi").get(`${BASE}/bookings`, ok, fail, params);
  });

// Itinerary filter options: [{ route, count }], most frequent first.
export const fetchItineraries = (params) =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi").get(`${BASE}/itineraries`, ok, fail, params);
  });

export const acceptBooking = (bookingId, fare) =>
  new Promise((resolve, reject) => {
    const [ok, fail] = handlers(resolve, reject);
    RequestFactory.withService("trnzApi")
      .setHeaders("Content-Type", "application/json")
      .withRequestBodyType("Json")
      .post(`${BASE}/bookings/${encodeURIComponent(bookingId)}/accept`, { fare }, ok, fail);
  });

// Multi accept: resolves { ok, status, body, message } instead of throwing, so
// the caller can tell "refused before sending" (4xx) from "result unknown".
export const acceptBatch = (items) =>
  new Promise((resolve) => {
    RequestFactory.withService("trnzApi")
      .setHeaders("Content-Type", "application/json")
      .withRequestBodyType("Json")
      .post(
        `${BASE}/bookings/accept-batch`,
        { items },
        (res) => {
          const ok = Boolean(res && res.status >= 200 && res.status < 300);
          resolve({ ok, status: res && res.status, body: res && res.body, message: ok ? "" : errorMessage(res) });
        },
        (err) => resolve({ ok: false, status: err && err.status, body: null, message: errorMessage(err) })
      );
  });

const resolveAll = (resolve) => [
  (res) => {
    const ok = Boolean(res && res.status >= 200 && res.status < 300);
    resolve({ ok, status: res && res.status, body: res && res.body, message: ok ? "" : errorMessage(res) });
  },
  (err) => resolve({ ok: false, status: err && err.status, body: null, message: errorMessage(err) }),
];

// Multi accept, queued: returns { batchId } at once; the server sends the
// bookings one by one. Poll fetchBatch(batchId) for progress.
export const acceptQueue = (items) =>
  new Promise((resolve) => {
    const [ok, fail] = resolveAll(resolve);
    RequestFactory.withService("trnzApi")
      .setHeaders("Content-Type", "application/json")
      .withRequestBodyType("Json")
      .post(`${BASE}/bookings/accept-queue`, { items }, ok, fail);
  });

export const fetchBatch = (batchId) =>
  new Promise((resolve) => {
    const [ok, fail] = resolveAll(resolve);
    RequestFactory.withService("trnzApi").get(`${BASE}/batches/${encodeURIComponent(batchId)}`, ok, fail);
  });
